import { useQuery } from '@tanstack/react-query';
import { api } from '../libs/axios';

interface useProps {
  dataSaida: string
  dataChegada: string
}

async function getResponse({ dataChegada, dataSaida }: useProps): Promise<{ valor: number }> {
    const response = await api.get('passagens/viagem-premiada', {
      params: {
        dataChegada, dataSaida
      },
    });

    return response.data;
}

export function useViagemPremiada({ dataChegada, dataSaida }: useProps) {
  return useQuery({
    queryKey: ['busca-viagem-premiada', {dataChegada, dataSaida}],
    queryFn: () => getResponse({ dataChegada, dataSaida }),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
